import { useEffect, useState } from "react";
import { useAppDispatch } from "@grassrootly/rn-core";
import { GetSeasonMatches, IGameView } from "@grassrootly/api";
import { competitionsActions } from "../../api/competitions/CompetitionsReducer";
import { useSeasonMatches } from "../../api/competitions/CompetitionsSelector";

export const useCompetitionMatches = (competitionId: number, seasonId: number) => {
  const dispatch = useAppDispatch();
  const matches = useSeasonMatches(seasonId);
  const [loading, setLoading] = useState(false);

  const fetchMatches = async () => {
    try {
      setLoading(true);
      const data = await GetSeasonMatches({ seasonId });
      dispatch(competitionsActions.setSeasonMatches({ seasonId, matches: data }));
    } catch (error) {
      console.error("Error fetching season matches:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (matches.length === 0) {
      fetchMatches();
    }
  }, [seasonId]);

  const refreshMatches = async () => {
    await fetchMatches();
  };

  return {
    matches,
    loading,
    refreshMatches,
  };
};
